import React from "react";
import { Box, Stack, styled } from "@mui/material";
import { ExitButton } from "./ExitButton";
import { LadderTitle } from "./LadderTitle";
import { LadderActivityLoading } from "./LadderActivityLoading";
import type { Ladder } from "../types";

const LadderTitleSpot = styled(Box)({
  label: "LadderTitleSpot",
  position: "absolute",
  top: "19px",
  left: "110px",
  right: "110px",
  width: "70%",
});

const AssessmentContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isGame",
})<{ isGame?: boolean }>(({ theme, isGame }) => ({
  label: "AssessmentContainer",
  width: "80%",
  marginTop: isGame ? "0%" : "20px",
  marginLeft: "5%",
  marginRight: "5%",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    marginTop: "30px",
    marginLeft: 0,
    marginRight: 0,
  },
}));

interface AssessmentLayoutProps {
  ladder: Ladder;
  divId: string;
  isGame?: boolean;
  loading: boolean;
  submitting: boolean;
  error: boolean;
  onExit: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  itemsApi: any;
  header?: React.ReactNode;
  children?: React.ReactNode;
}

export const AssessmentLayout = ({
  ladder,
  divId,
  isGame,
  loading,
  submitting,
  error,
  onExit,
  itemsApi,
  header,
  children,
}: AssessmentLayoutProps) => {
  const onExitButton = () => {
    if (itemsApi) {
      if (itemsApi.save) itemsApi.save();
    }
    onExit();
  };

  if (error) {
    return <div>Error loading assessment</div>;
  }

  return (
    <>
      <Stack sx={{ paddingTop: "20px", paddingLeft: "10px" }}>
        <ExitButton onClick={onExitButton} />
      </Stack>
      <LadderTitleSpot>
        <LadderTitle ladder={ladder} />
      </LadderTitleSpot>
      {header && <Box sx={{ mt: { xs: "40px", sm: 0 } }}>{header}</Box>}
      <AssessmentContainer
        isGame={isGame}
        className={`ladder-assessment-container ${ladder.ladderType} ladder-id-${ladder.id}`}
      >
        <div
          id={divId}
          style={{
            width: "100%",
          }}
        />
      </AssessmentContainer>
      {children}
      {(loading || submitting) && (
        <LadderActivityLoading
          label={submitting ? "Saving Results" : "Loading Assessment"}
        />
      )}
    </>
  );
};
